import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getProducts = async () => {
  const { data } = await axios.get(`${API}/products`);
  return data;
};

export const getPosts = async () => {
  const { data } = await axios.get(`${API}/posts`);
  return data;
};

export const getPost = async (slug) => {
  const { data } = await axios.get(`${API}/posts/${slug}`);
  return data;
};

export const submitEnquiry = async (payload) => {
  const { data } = await axios.post(`${API}/enquiries`, payload, { timeout: 45000 });
  return data;
};

export const formatMoney = (n) => `$${Number(n).toLocaleString("en-US")}`;
